<div class="text-center mt-1">
    <img src="/assets/images/04-06-10-848_512.webp" class="gif-img" alt="">
    <h5 class="mb-3 mt-2">Are You Sure</h5>
    <div>
        <button class="mr-2" mat-raised-button color="warn" (click)="cancelReason()">NO</button>
        <button mat-raised-button color="primary" (click)="approval()">YES</button>
    </div>

</div>